<script setup lang="ts">
import MessagePlain from '@/views/chat/components/message-plain.vue'
import { marked } from 'marked'
import { computed } from 'vue'
import type { IResponseMarkdown, ResponseMessageTType } from '@/types'
import { useMessageComponent } from '@/views/chat/components/composition'

const props = defineProps<{ data: ResponseMessageTType<IResponseMarkdown> }>()
const { plainAttrs } = useMessageComponent(props.data)
const md = computed(() => {
  return marked.parse(props.data?.markdownResponse.text || '')
})
</script>

<template>
  <message-plain v-bind="plainAttrs">
    <div v-html="md" />
  </message-plain>
</template>

<style scoped lang="scss"></style>
